import { selector } from 'recoil';

import { enquiryListDataAtom, enquiryListStatusAtom } from './enquiry.atom';
import { EnquiryListState } from './enquiry.interface';

export const enquiryListStateSelector = selector<EnquiryListState>({
  key: 'enquiryListStateSelector',
  get: ({ get }) => {
    return {
      status: get(enquiryListStatusAtom),
      data: get(enquiryListDataAtom),
    };
  },
});
